import classNames from 'classnames'

interface IProps {
  className?: string
}

export const VertSpacerMd: React.FC<IProps> = ({ className }) => <div className={classNames('pt-3', className)} />
